// frontend/src/pages/RevitPluginPage.tsx
import React from "react";
import { Box, Container, Stack, Title } from "@mantine/core";
import { DownloadRevitPlugin } from "./DownloadRevitPlugin";
import { UploadRevitPlugin } from "./UploadRevitPlugin";
import { useAppSelector } from "../app/hooks";
import { MEDIA_ASSET_KEYS } from "@multiconsult-group/multiplacer-core";
import { MediaAssetViewer } from "../MediaAssets/MediaAssetViewer";
import { selectIsSystemAdmin } from "../userSelectors";

export const RevitPluginPage: React.FC = () => {
  const userIsAdmin = useAppSelector(selectIsSystemAdmin);

  return (
    <Container size="md" py="lg" style={{ height: "100vh" }}>
      {/* Scrollbart sideinnhold */}
      <Box style={{ height: "100%", overflowY: "auto" }}>
        <Stack gap="md">
          <Title order={2}>Revit-plugin</Title>

          <MediaAssetViewer mode="EXPANDED" assetKey={MEDIA_ASSET_KEYS.REVIT_DEMO} />

          <DownloadRevitPlugin />
          {userIsAdmin && <UploadRevitPlugin />}
        </Stack>
      </Box>
    </Container>
  );
};
